import { Group, Message, User } from 'able-lib'
import { Room } from 'components/ChatWindow/model'

export interface MessageStateInterface {
  conversationType: ConversationType;
  conversations: Array<Room>;
  conversationsUnreadMessages: Array<any>;
  conversation: any;
  messages: Array<any>;
  chatMessageDraft: Group;
  contacts: Array<User>;

  unreadMessages: Array<Group>;

  announcements: Array<Message>;
  announcement: Message;
  unreadAnnouncementCount: number;

  policies: Array<Message>;

  messageRecipients: Array<User>;
}

export enum ConversationType {
  DIRECT = 'DIRECT',
  GROUP = 'GROUP'
}

export default function () {
  return {
    // Messaging
    conversationType: ConversationType.DIRECT, // DIRECT or GROUP
    // conversations is for listing on side bar, should only contain 1 latest message
    conversations: [],
    // list of count of unread messages per conversation
    conversationsUnreadMessages: [],
    // active conversation or messages
    conversation: null,
    messages: [],
    // the input of the client
    chatMessageDraft: null,

    // Messaging Tools
    unreadMessages: [],
    contacts: [],
    // Announcement
    announcements: [],
    announcement: null,
    unreadAnnouncementCount: 0,

    // Policies
    policies: [],

    messageRecipients: []
  }
}
